// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';
import classNames from 'classnames';

import './menu_header.scss';
import {MenuContext} from './menu_context';

type Props = {
    divider?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
}

export default class MenuHeader extends React.PureComponent<Props> {
    declare context: React.ContextType<typeof MenuContext>

    public static contextType = MenuContext;

    hideSubmenuItem = () => this.context.onCloseSubMenuItem();

    public render() {
        const {className, children} = this.props;

        return (
            <li className={classNames('MenuHeader', className)} onMouseEnter={this.hideSubmenuItem}>
                {children}
            </li>
        );
    }
}
